import { createContext } from 'react'

export const WorkspaceListContext = createContext(null)
